import React from 'react';
import styles from './card.module.css';

const CarouselCard = ({logo, url, desc}) => {
  return <div className={styles.section}>
    <a href="http://afterschool.my/international-education-college" className={styles.link} />
    <div className={styles.card}>
      <div className={styles.logoDiv}>
          <img src="http://images.afterschool.my/admin/uploads/images/59376/logo/large/logo.png" alt="Collage logo" className={styles.img} />
      </div>
        <div className={styles.schoolHeader}>INTEC Education College</div>
      </div>
    </div>
}

export default CarouselCard;



// WEBPACK FOOTER //
// ./src/components/Carousel/CarouselCard/index.js